import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';

// The inversify container and its lazyInject decorator live HERE (separate from
// context/module.ts) so that services which are themselves BOUND in the container
// can import `lazyInject` WITHOUT creating a circular import:
//
//   login.service.ts -> context/module.ts -> (binds) login.service.ts   ❌ cycle
//   login.service.ts -> context/container.ts                            ✅ no cycle
//
// context/module.ts imports `container` from here, registers every binding, and
// re-exports `container` + `lazyInject` so all existing
// `import { container, lazyInject } from '.../context/module'` call sites keep
// working unchanged.

// Must have https://www.npmjs.com/package/babel-plugin-transform-typescript-metadata
export const container = new Container({ autobind: true, defaultScope: 'Singleton' });

// setup the container...
const { lazyInject: originalLazyInject } = getDecorators(container);

// Additional function to make property decorators compatible with babel.
function fixPropertyDecorator<T extends Function>(decorator: T): T {
    return ((...args: any[]) => (
        target: any,
        propertyName: any,
        ...decoratorArgs: any[]
    ) => {
        decorator(...args)(target, propertyName, ...decoratorArgs);
        return Object.getOwnPropertyDescriptor(target, propertyName);
    }) as any;
}

export const lazyInject = fixPropertyDecorator(originalLazyInject);
